<template>
  <p :class="textClassObject" :style="{ fontSize:  textSize}"><slot></slot></p>
</template>

<script>
export default {
  name: "ri-clothes-text",
  props: {
    textSize: {
      textSize: String,
      default: "1rem"
    },
    textType: {
      textType: String,
      default: "default"
    },
    isBottomBorder: {
      isBottomBorder: Boolean,
      default: false
    }
  },
  computed: {
    textClassObject: function() {
      let appendTextType = "";
      if(this.textType != "default" && this.textType != "") {
        appendTextType = `__${this.textType}`;
      }
      return {
        [`riclothes-text${appendTextType}`]: true,
        [`riclothes-text--border`]: this.isBottomBorder,
        dark: this.$root.config.isDarkTheme
      }
    }
  }
}
</script>

<style scoped lang="scss">
.riclothes-text {
  --riclothes-text-color: var(--text-color);

  --riclothes-text-color-high: #212121;
  --riclothes-text-color-medium: #666666;
  --riclothes-text-color-disabled: #9e9e9e;

  color: var(--riclothes-text-color);
  padding: 0px;
  margin: 0px;
  transition: 0.5s;
  text-align: left;

  &--border {
    border-bottom: medium solid var(--riclothes-text-color);
  }

  &__high {
    @extend .riclothes-text;
    --riclothes-text-color: var(--riclothes-text-color-high);
  }

  &__medium {
    @extend .riclothes-text;
    --riclothes-text-color: var(--riclothes-text-color-medium);
  }

  &__disabled {
    @extend .riclothes-text;
    --riclothes-text-color: var(--riclothes-text-color-disabled);
  }
}

.dark {
  --riclothes-text-color-high: #e0e0e0;
  --riclothes-text-color-medium: #c0c0c0;
  --riclothes-text-color-disabled: #6c6c6c;
}
</style>